import type { HubConnection } from "@microsoft/signalr/dist/esm/HubConnection";
import type { CashierServerHub } from "./walletapi";



// export interface ApiConnection
// {
//     connection: HubConnection;
//     connected: boolean;
// }

class Services
{
    protected _connection: HubConnection | null = null;
    public get connection(): HubConnection
    {
        if (!this._connection)
        {
            throw new Error("connection not set");
        }

        return this._connection;
    }

    public UpdateConnection(connection: HubConnection)
    {
        this._connection = connection;
    }

    protected _connected: boolean = false;
    public get connected(): boolean
    {
        return this._connected;
    }

    public UpdateConnected(connected: boolean)
    {
        this._connected = connected;
    }

    protected _walletapi: CashierServerHub | null = null;
    public get walletapi(): CashierServerHub
    {
        if (!this._walletapi)
        {
            throw new Error("walletapi not set");
        }

        return this._walletapi;
    }

    public UpdateApi(api: CashierServerHub)
    {
        this._walletapi = api;
    }

    protected _server: URL | null = null;
    public get server(): URL | null
    {
        return this._server;
    }

    public UpdateServer(server: URL)
    {
        this._server = server;
    }

    public Route(endpoint: string): URL
    {
        if (!this._server)
        {
            throw new Error("Server not set");
        }

        const newUrl = new URL(this._server.href);

        // remove / from path
        if (endpoint.startsWith('/'))
        {
            endpoint = endpoint.substring(1);
        }
      
        // Ensure the path does not end with a slash, if the current path has one
        if (!newUrl.pathname.endsWith('/'))
        {
            newUrl.pathname += '/' + endpoint;
        }
        else
        {
            newUrl.pathname += endpoint;
        }
      
        return newUrl;
    }
}

export const service = new Services();
